import React, { forwardRef } from "react";

import defaultStyles from "./main.module.scss";

export const LARGE_MODAL_SIZE = "LARGE";
export const MEDIUM_MODAL_SIZE = "MEDIUM";

type ModalCommonUtilProps = {
  styles?: ModularStyles;
};

export const CloseButton = forwardRef<
  HTMLButtonElement,
  ModalCommonUtilProps & React.ComponentPropsWithoutRef<"button">
>(({ styles = defaultStyles, className = "", children, ...rest }, ref) => (
  <button
    aria-label="Close"
    tabIndex="0"
    className={`${styles.closeModal} ${className}`}
    {...rest}
    ref={ref}
  >
    {children}
  </button>
));

export const ModalBody = forwardRef<
  HTMLDivElement,
  ModalCommonUtilProps & React.ComponentPropsWithoutRef<"div">
>(({ styles = defaultStyles, className = "", children, ...rest }, ref) => (
  <div ref={ref} className={`${styles["modal-body"]} ${className}`} {...rest}>
    {children}
  </div>
));

export const ModalContent = forwardRef<
  HTMLDivElement,
  ModalCommonUtilProps & React.ComponentPropsWithoutRef<"div">
>(({ styles = defaultStyles, className = "", children, ...rest }, ref) => (
  <div className={`${styles["modal-content"]} ${className}`} ref={ref} {...rest}>
    {children}
  </div>
));

export const ModalHeader: React.FC<ModalCommonUtilProps & React.ComponentPropsWithRef<"div">> = ({
  styles = defaultStyles,
  className = "",
  children,
  ...rest
}) => (
  <div className={`${styles["modal-header"]} ${className}`} {...rest}>
    {children}
  </div>
);

export const ModalFooter: React.FC<ModalCommonUtilProps & React.ComponentPropsWithRef<"div">> = ({
  styles = defaultStyles,
  className = "",
  children,
  ...rest
}) => (
  <div className={`${styles["modal-footer"]} ${className}`} {...rest}>
    {children}
  </div>
);

export const ModalDialog = forwardRef<
  HTMLDivElement,
  ModalCommonUtilProps & React.ComponentPropsWithoutRef<"div"> & { size?: number }
>(({ styles = defaultStyles, className = "", children, size = 0, ...rest }, ref) => {
  const modalSizeClassMapping = {
    [LARGE_MODAL_SIZE]: styles.largeModal,
    [MEDIUM_MODAL_SIZE]: styles.mediumModal,
  };
  const modalDialogClassName = `${styles["modal-dialog"]} ${className} ${
    modalSizeClassMapping[size] || ""
  }`;
  return (
    <div className={modalDialogClassName} {...rest} ref={ref} data-acsb-overlay="popup">
      {children}
    </div>
  );
});
